import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import NoDataBanner from "components/common/NoDataBanner";
import Typography from "components/common/Typography";
import { setRecentlyViewed, setSelectedList } from "components/features/Corp/CorpUser.Slice";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { setSelectedMyList } from "utils/CommonFunctions";
import "../../../../../src/index.scss";
import { getUrl, recentlyViewedDataCorpUser, recentlyViewedDataHotelUser } from "./RecentlyViewed";

interface Props {
  keyCategory: string;
  dataList: any;
  name?: string;
  inncode?: string;
  htlid?: string;
  urlId?: string;
}

const RecentData = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const recentlyViewedCategory = useAppSelector((state) => state.CorpDashboard.recentlyViewedSelected.category);

  const recentlyViewedData = isCorp ? recentlyViewedDataCorpUser : recentlyViewedDataHotelUser;

  const { keyCategory, dataList } = props;
  const { title = "", Icon = () => null, key1 = "", key2 = "" } = recentlyViewedData?.[keyCategory] ?? {};
  const dataLength = dataList?.length ? "" : "no-data-banner";

  return (
    <Accordion className="view-recent-data-accordion" defaultExpanded={keyCategory === recentlyViewedCategory}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="view-recent-data-accordion-summary">
        <Typography variant="body2">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={`view-recent-data-accordion-detail ${dataLength}`}>
        {dataList?.length > 0 ? (
          <>
            {dataList?.map((el: any) => {
              return (
                <div
                  key={el.id}
                  style={{ display: "flex" }}
                  className="view-recent-data-wrapper"
                  onClick={() => {
                    navigate(getUrl(keyCategory, el, recentlyViewedData), {
                      state: {
                        isMyLists: true,
                        defaultTab: 0,
                        fromDashboard: true,
                        innCode: DEFAULT_CORP_INNCODE
                      }
                    });
                    dispatch(setRecentlyViewed({ category: keyCategory, item: el[key1] }));
                    dispatch(setSelectedList({}));
                    if (keyCategory === "myList") {
                      setSelectedMyList(dispatch, el, el?.filterType);
                    }
                  }}
                >
                  <div className="view-recent-data-icon">
                    <Icon />
                  </div>
                  <div className="view-recent-data-text">
                    {el[key1] !== null && el[key1] !== undefined && (
                      <Typography variant={"body2"} className="ellipse-two">
                        {`${el[key1]}`}
                      </Typography>
                    )}
                    {key2 !== null && key2 !== undefined && (
                      <Typography variant={"body2"} showBold className="ellipse-one">
                        {`${el[key2]}`}
                      </Typography>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="recently-viewed-no-data-banner">
            {" "}
            <NoDataBanner noDataMessage={`No Recently Viewed ${title}`} />
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
export default RecentData;
